module.exports = __webpack_public_path__ + "img/destination-8.a52f048a.svg";